function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "logo");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "logo",
  transform: "translate(2.000000, -1.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(91.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("text", {
  id: "TEXT",
  fontFamily: "Roboto-Regular, Roboto",
  fontSize: 62.37,
  fontWeight: "normal",
  letterSpacing: -1.41749999,
  fill: "#4D4D4D"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0.20625484,
  y: 58
}, "TEXT")), /*#__PURE__*/React.createElement("text", {
  id: "PAY",
  fontFamily: "Roboto-Bold, Roboto",
  fontSize: 62.3889,
  fontWeight: "bold",
  fill: "#8B6BD9"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 147.255,
  y: 58
}, "PAY"))), /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(0.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M54.4561875,-6.23501251e-14 C62.3435386,-6.55753648e-14 68.7375,6.3939614 68.7375,14.2813125 L68.7375,45.6811875 C68.7375,53.5685386 62.3435386,59.9625 54.4561875,59.9625 L49.721,59.962 L49.7217072,77.9293125 L38.485,59.962 L14.2813125,59.9625 C6.3939614,59.9625 2.69225261e-15,53.5685386 0,45.6811875 L0,14.2813125 C-2.74227877e-15,6.3939614 6.3939614,-6.09012422e-14 14.2813125,-6.23501251e-14 L54.4561875,-6.23501251e-14 Z",
  id: "Combined-Shape",
  stroke: "#8B6BD9",
  strokeWidth: 3.6855,
  fill: "#8B6BD9"
}), /*#__PURE__*/React.createElement("text", {
  id: "$",
  fontFamily: "Roboto-Medium, Roboto",
  fontSize: 44.055375,
  fontWeight: 400,
  letterSpacing: -1.00125843,
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 20.5300051,
  y: 44.9
}, "$")))));

var SvgTextpayLogo = function SvgTextpayLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "359px",
    height: "87px",
    viewBox: "0 0 359 87",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTextpayLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/textpay-logo.d988e22f.svg";
export { ForwardRef as ReactComponent };